import http from '~/common/http'


/** 删除文件 */
function del(params){
    return http.delete('api/common/delete-contract',{
        params: params
    })
}

function upload(params){
    return http.post('api/common/upload-contract',{
        params: params
    })
}


export default {
    del,
    upload
}


// WEBPACK FOOTER //
// ./src/services/attachment.js